// extracted by mini-css-extract-plugin
export default {"QuickActions":"QuickActions_QuickActions__8ZMqj","CollapsedQuickActions":"QuickActions_CollapsedQuickActions__9lawC"};